import { render, staticRenderFns } from "./corporate.vue?vue&type=template&id=632e7073&scoped=true&"
import script from "./corporate.vue?vue&type=script&lang=js&"
export * from "./corporate.vue?vue&type=script&lang=js&"
import style0 from "../../templateAssests/css/home.css?vue&type=style&index=0&id=632e7073&scoped=true&lang=css&"
import style1 from "./corporate.vue?vue&type=style&index=1&id=632e7073&scoped=true&lang=css&"
import style2 from "./corporate.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632e7073",
  null
  
)

export default component.exports